import { jsxs, jsx } from "react/jsx-runtime";
import { Component } from "react";
import PropTypes from "prop-types";
import ChatIcon from "./ChatIcon.js";
class ErrorView extends Component {
  render() {
    return /* @__PURE__ */ jsxs("div", { id: "chat-view", className: "error-view", children: [
      /* @__PURE__ */ jsx("span", { className: "oops-something-went-wrong", children: "Oops, something went wrong" }),
      /* @__PURE__ */ jsx("div", { className: "sad-cardboard", children: /* @__PURE__ */ jsx(ChatIcon, { className: "large" }) }),
      /* @__PURE__ */ jsxs("div", { className: "try-again", children: [
        /* @__PURE__ */ jsx("span", { children: "Please check your internet connection and try again" }),
        /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
          "button",
          {
            className: "try-again-button",
            onClick: this.props.onTryAgainClick,
            children: "Try Again"
          }
        ) })
      ] })
    ] });
  }
}
ErrorView.propTypes = {
  onTryAgainClick: PropTypes.func
};
export {
  ErrorView as default
};
//# sourceMappingURL=ErrorView.js.map
